import { Messaging } from '../components/Campaigns/WebPush/Messasging';
import PageMain from '../components/Navigation/PageMain/PageMain';

export function WebPushPage() {
    return (
        <PageMain pageTitle="Web Push Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <Messaging />
                </div>
            </div>
        </PageMain>
    );
}
